import React from 'react';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';

import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import SecondaryButton from '../../../partials/customButtons/SecondaryButton';
import ConfirmDialog from '../../../partials/confirmationDialog/ConfirmDialog';

export function ActionsButtons({ onCloseClick, handleSubmit, dirty, intl }) {
  return (
    <>
      <PrimaryButton onClick={handleSubmit} disabled={!dirty}>
        {intl.formatMessage({
          id: 'BUTTON.SAVE'
        })}
      </PrimaryButton>
      <ConfirmDialog
        onConfirmClick={onCloseClick}
        dialogTextIntlId={'NOT_SAVED'}
        dialogTitleIntlId={'WARNING'}
        valueToCheck={dirty}
        isWarning={true}
      >
        <SecondaryButton>
          {intl.formatMessage({
            id: 'BUTTON.CANCEL'
          })}
        </SecondaryButton>
      </ConfirmDialog>
    </>
  );
}

export default flowRight(injectIntl)(ActionsButtons);
